"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const dom_1 = __importDefault(require("@amzn/awsui-components-react/test-utils/dom"));
exports.default = (element) => {
    const domContainer = document.createElement('div');
    react_dom_1.default.render(element, domContainer);
    const wrapped = dom_1.default(domContainer);
    // @ts-ignore
    wrapped.update = (nextProps) => {
        react_dom_1.default.render(react_1.default.cloneElement(element, { ...element.props, ...nextProps }), domContainer);
    };
    return wrapped;
};
//# sourceMappingURL=Mount.js.map